import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { MunicipalityOnboardingModalComponent } from './municipality-onboarding-modal/municipality-onboarding-modal.component';
import { MunicipalityOnboardingResultModalComponent } from './municipality-onboarding-result-modal/municipality-onboarding-result-modal.component';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';

@Component({
  selector: 'app-municipality-onboarding',
  templateUrl: './municipality-onboarding.component.html',
  styleUrls: ['./municipality-onboarding.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MunicipalityOnboardingComponent implements OnInit, OnDestroy {
  searchValue: string = '';
  searchField = new FormControl('');
  onboardingDetails: any;

  private readonly destroy$ = new Subject<void>();

  constructor(private readonly dialog: MatDialog, private overlayLoaderService: OverlayLoaderService) {}

  ngOnInit() {
    this.overlayLoaderService.setLoadingToFalse();
    this.overlayLoaderService.ignoreChanges = true;
    this.onFilterClear();
  }

  ngOnDestroy(): void {
    this.overlayLoaderService.ignoreChanges = false;
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * reset datasource filter on clear of search field value
   */
  onFilterClear(): void {
    this.searchField.valueChanges.pipe(takeUntil(this.destroy$), debounceTime(150), distinctUntilChanged()).subscribe((searchQuery) => {
      if (searchQuery === '') {
        this.searchValue = searchQuery;
      }
    });
  }

  onAddMunicipalityClick(): void {
    const dialogRef = this.dialog.open(MunicipalityOnboardingModalComponent, {
      panelClass: ['-md', 'add-municipality-dialog'],
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.onboardingDetails = result;
      if (result !== undefined) {
        this.dialog.open(MunicipalityOnboardingResultModalComponent, {
          data: result,
          panelClass: ['-md', 'municipality-onboarding-result-dialog'],
          disableClose: true,
        });
      }
    });
  }

  /**
   *
   * @param searchTerm search value
   */
  searchInputChanged(searchTerm: string): void {
    this.searchValue = searchTerm;
  }
}
